import config from '../config'
import http from '../http'
import { getOverviewData as mockGetOverviewData } from '@/mock/energyQuery'

export function getOverviewData(params) {
  if (config.useMock) {
    return mockGetOverviewData(params)
  }
  return http.get(`${config.api}/energy/query/overview`, { params }).then(res => res.data)
}
